import React, { useState, useEffect } from "react";
import { Modal, Form, message } from "antd";
import { updateAdmin } from "../../../services/AdminPortalAPIs";
import { roles } from "./SettingsColumn";
import StyledTextInput from "src/components/reusable/StyledTextInput";
import StyledDropdown from "src/components/reusable/StyledDropdown";

interface EditAdminModalProps {
  open: boolean;
  admin: { name: string; email: string; role: string };
  onClose: () => void;
  onSuccess: () => void;
}

const EditAdminModal: React.FC<EditAdminModalProps> = ({
  open,
  admin,
  onClose,
  onSuccess,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        new_user_name: admin.name,
        new_role_name: admin.role,
        email: admin.email,
      });
    }
  }, [open, admin, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      await updateAdmin({ ...values, target_email: admin.email });
      message.success("Admin updated successfully");
      onSuccess();
      onClose();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      message.error("Failed to update admin");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      title="Edit Admin"
      okText="Save"
      onCancel={onClose}
      onOk={handleSubmit}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="email" label="Email">
          <StyledTextInput disabled  aria-label="Admin Email"/>
        </Form.Item>
        <Form.Item
          name="new_user_name"
          label="Name"
          rules={[{ required: true, message: "Please enter the name" }]}
        >
          <StyledTextInput aria-label="Admin Name" />
        </Form.Item>
        <Form.Item
          name="new_role_name"
          label="Role"
          rules={[{ required: true, message: "Please select a role" }]}
        >
          <StyledDropdown
            aria-label="Admin Role"
            options={roles.map(role => ({ value: role, label: role }))}
            popupClassName="custom-dropdown-menu"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditAdminModal;
